import RequestHandler from '../../customize/requestHandler';

export const GetCountries = async () => {
	return RequestHandler.call({ url: '/api/v1/countries?limit=300', method: 'get' }).then(res => res.data.result);
};
